const styles = theme => ({
    body: {
        backgroundColor: theme.palette.background.default,
        padding: 0
    },

    evidenceAttached: {
        backgroundColor: theme.palette.secondary.main
    },

    evidenceButton: {
        right:220,
        '@media (max-width: 380px)': {
            right: 155,
            bottom: -10
        }
    }
});

export default styles;